import { getGlobalData } from "utils/api";
import { cookieNoticeMDX } from "utils/constants";
import { getLocalizedPaths } from "utils/localize";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";
import Document from "@/components/brandRefresh/document";

function CookieNotice({ metadata, mdxData }) {
  return (
    <>
      <RefreshHeader metadata={metadata}>
        <div className="flex flex-col text-sm md:text-base">
          <Document data={mdxData} />
        </div>
      </RefreshHeader>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `Cookie Notice`,
  };

  return {
    props: {
      metadata,
      title: "Cookie Notice",
      global: globalLocale.data,
      mdxData: cookieNoticeMDX,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}

export default CookieNotice;
